export default __webpack_public_path__ + "static/media/gallery_06.662b28f7.jpg";